import request from '@/utils/request'

/**
 * 查询店铺仓库列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopHouses(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse.queryAdminShopHouse',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加店铺仓库
 * @param {Object} data 仓库数据
 * @returns {Promise} Promise对象
 */
export function addShopHouse(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse.saveShopHouse',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新店铺仓库
 * @param {Object} data 仓库数据
 * @returns {Promise} Promise对象
 */
export function updateShopHouse(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse.updateShopHouse',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除店铺仓库
 * @param {String} shId 仓库ID
 * @returns {Promise} Promise对象
 */
export function deleteShopHouse(shId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse.deleteShopHouse',
      method: 'post',
      data: { shId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function getShopHouseList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse.queryAdminShopHouse',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}